import React, { useEffect, useState } from 'react';
import '../ManageProjectsByEmployees.css';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../../utils/axiosInstance';

const MonthsWorkStatOfSelectedProject = ({ totalDuration }) => {
    const { t } = useTranslation();
    const [currentMonth, setCurrentMonth] = useState('');
    const [currentYear, setCurrentYear] = useState('');

    // Helper function to get the month name
    const getMonthName = (monthIndex) => {
        const months = [
            'January', 'February', 'March', 'April', 'May',
            'June', 'July', 'August', 'September', 'October',
            'November', 'December'
        ];
        return months[monthIndex];
    };

    useEffect(() => {
        const currentDate = new Date();
        setCurrentMonth(getMonthName(currentDate.getMonth()));
        setCurrentYear(currentDate.getFullYear());
    }, []);

    return (
        <div className='WorkStat-body'>
            <div className='WorkStat-worked-headerbody'>
                <div className='WorkStat-worked-header'>
                    <span>{t("employeeWorkDetails_month")}</span>
                    <span style={{ fontSize: '10px' }}>HH-MM-SS</span>
                </div>
            </div>
            <div className='WorkStat-worked-duration'>
                {totalDuration}
            </div>
            <div className='WorkStat-worked-footer'>
                {currentMonth} {currentYear}
            </div>
        </div>
    );
};

export default MonthsWorkStatOfSelectedProject;
